/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';

export const opportunityCandidateInstantMatchSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  orderNumber: z.number().int().nullish(),
  passed: z.boolean(),
  pinnedByClient: z.boolean(),
  rate: z.number().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type OpportunityCandidateInstantMatch = z.infer<typeof opportunityCandidateInstantMatchSchema>;
